import { css } from 'styled-components';
import {
  getSpacing, SpacingName, ThemedFunctor,
} from '@doveit/lego';

export const box: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.padding(theme, SpacingName.MEDIUM)}
  text-align: center;
  border: 1px solid ${theme.palettes.neutrals.light};
  background-color: ${theme.palettes.neutrals.lightest};
  border-radius: 6px;
  height: 100%;
`;

export const featuredLogoContainer: ThemedFunctor = () => css`
  display: flex;
  align-items: center;
  height: 100%;
`;

export const featuredLogoImage: ThemedFunctor = () => css`
  width: 100%;
  display: block;
`;

export const featuredArticleCard = ({
  theme,
}) => css`
  border-top: 1px solid ${theme.palettes.neutrals.light};
  ${getSpacing.paddingTop(theme, SpacingName.MEDIUM)};
  ${getSpacing.marginTop(theme, SpacingName.MEDIUM)};

  &:first-child {
    border-top: 0;
    padding-top: 0;
    margin-top: 0;
  }

  a {
    color: currentColor;
    text-decoration: none;
  }
`;

export const articleCard = () => css`
  a {
    color: currentColor;
    text-decoration: none;
  }
}
`;

export const pressReleaseCard = ({
  theme,
}) => css`
  ${getSpacing.padding(theme, SpacingName.SMALL)};
  ${getSpacing.marginTop(theme, SpacingName.SMALL)};
  border: 1px solid ${theme.palettes.neutrals.light};
  position: relative;
  border-radius: 6px;
  background-color: ${theme.palettes.neutrals.lightest};
  padding-right: 5rem!important;
  display: block;
  text-decoration: none;

  &:first-child {
    margin-top: 0;
  }
`;

export const pressReleaseCardIcon = ({
  theme,
}) => css`
  ${getSpacing.paddingRight(theme, SpacingName.SMALL)};
  position: absolute;
  top: 50%;
  right: 0;
  line-height: 0;
  transform: translateY(-50%);
  color: ${theme.palettes.neutrals.medium};
`;
